import { sendMetricaGoal } from "@simble/shared/lib/metrica";
import LoadingIndicator from "@simble/ui/loading-indicator";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import Header from "@/components/header";
import ConvientProduct from "@/components/home/convenient-product";
import Faq from "@/components/home/faq";
import Hero from "@/components/home/hero";
import Minmax from "@/components/home/minmax";
import ProtectedBlock from "@/components/home/protected-block";
import Why from "@/components/home/why";
import PageLayout from "@/layouts/page-layout";

const RatesPage = () => {
  useEffect(() => {
    sendMetricaGoal("web_view_main");
  }, []);

  return (
    <PageLayout className="pb-16" container="fluid" header={<Header className="absolute inset-x-0 z-10 mx-auto max-w-[1028px]" />}>
      <Hero />
      <div className="mx-auto px-5 md:max-w-[1028px] md:px-8">
        <ConvientProduct />
        <ProtectedBlock />
        <Why />
        <Minmax />
        <Faq />
      </div>
    </PageLayout>
  );
};

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Партнерский кабинет" },
      {
        name: "description",
        content: "Оформление страховки КАСКО на парковке",
      },
    ],
  }),
  component: RatesPage,
  pendingComponent: LoadingIndicator,
});
